/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChatGptCallDto } from '../../models/chat-gpt-call-dto';
import { ChatGptResponseDto } from '../../models/chat-gpt-response-dto';

export interface ProxyControllerCallChatGptApi$Params {
  ilsId: string;
      body: ChatGptCallDto
}

export function proxyControllerCallChatGptApi(http: HttpClient, rootUrl: string, params: ProxyControllerCallChatGptApi$Params, context?: HttpContext): Observable<StrictHttpResponse<ChatGptResponseDto>> {
  const rb = new RequestBuilder(rootUrl, proxyControllerCallChatGptApi.PATH, 'post');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChatGptResponseDto>;
    })
  );
}

proxyControllerCallChatGptApi.PATH = '/proxy/{ilsId}/chatGpt';
